// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
//baseUrl: 'http://difritz-web-api.test/api/', //local
//baseUrlPuclic: 'http://difritz-web-api.test' //local
   
//baseUrl: 'https://dev.difritz.sb-sistemas.com/api/', //Test
//baseUrlPuclic: 'https://dev.difritz.sb-sistemas.com' //Test
    
baseUrl: 'https://difritz.sb-sistemas.com/api/', //PRODUCCION
baseUrlPuclic: 'https://difritz.sb-sistemas.com' //PRODUCCION

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
